import React, { ChangeEventHandler } from "react";

type AvailableTypes = "text" | "search" | "email" | "password";
type AvailableVariants = "full" | "underline";

interface IBaseInputProps {
  type: AvailableTypes;
  placeholder: string;
  label: string;
  value: string;
  name: string;
  error: string | undefined;
  onChange?: (value: string) => void;
  formikOnChange?: any;
  onBlur: ChangeEventHandler;
  variant?: AvailableVariants;
}

const BaseInput = ({
  label,
  error,
  value,
  type,
  name,
  placeholder,
  onChange,
  formikOnChange,
  onBlur,
  variant = "full",
}: IBaseInputProps) => {
  let onChangeFunction = () => {};
  if (onChange) {
    // @ts-ignore
    onChangeFunction = ({ target }) => onChange(target.value);
  } else if (formikOnChange) {
    onChangeFunction = formikOnChange;
  }
  return (
    <label className="flex flex-col w-full min-w-[100px]">
      <span
        className={`${
          variant === "underline" ? "hidden" : ""
        } mb-[6px] font-primary text-mobile-heading-6 md:text-desktop-heading-6 font-bold`}
      >
        {label}
      </span>
      <input
        className={`${
          variant === "full" ? "border-1 rounded-5" : "border-b-1"
        } py-[17px] px-[12px] text-[16px] w-full border-grey-600 focus:outline-none focus:border-black`}
        type={type}
        name={name}
        placeholder={placeholder}
        onChange={onChangeFunction}
        onBlur={onBlur}
        value={value}
      />
      <p
        className={`text-core-red text-[12px] h-[18px] mt-[4px] ${
          !error ? "opacity-0" : ""
        }`}
      >
        {error}
      </p>
    </label>
  );
};

export default BaseInput;
